Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snack = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _generalObserver = require("../general-observer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var scriptUrl = 'https://snack.expo.io/embed.js';
var Snack = function Snack(_ref) {
  var snackId = _ref.snackId,
    _ref$platform = _ref.platform,
    platform = _ref$platform === void 0 ? 'web' : _ref$platform,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme;
  var handleScriptLoad = function handleScriptLoad() {
    (0, _utils.createScriptTag)(scriptUrl, null);
  };
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: handleScriptLoad
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "snack-mdx-embed",
    "data-testid": "snack",
    "data-snack-id": snackId,
    "data-snack-platform": platform,
    "data-snack-preview": "true",
    "data-snack-theme": theme,
    style: {
      overflow: 'hidden',
      background: '#F9F9F9',
      border: '1px solid var(--color-border)',
      borderRadius: '4px',
      height: '505px',
      width: '100%'
    }
  }));
};
exports.Snack = Snack;